/**
 * The grace period between a pointer leaving something and that thing closing. Long enough that a
 * wobble across the edge does not snap it shut, and cancelled outright when the pointer comes back.
 *
 * Stateful, so it belongs here beside the components rather than in tools/, which holds pure statics.
 */
export class HoverCloseTimer {
  public static readonly graceMs = 250;

  private handle: ReturnType<typeof setTimeout> | undefined;

  public schedule(close: () => void): void {
    this.cancel();
    this.handle = setTimeout(close, HoverCloseTimer.graceMs);
  }

  public cancel(): void {
    if (this.handle !== undefined) {
      clearTimeout(this.handle);
      this.handle = undefined;
    }
  }
}
